import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { CssBaseline, ThemeProvider } from "@mui/material";

import KeycloakService from "./keyCloak/KeycloakService";

import { globalTheme } from "./theme/globalTheme";

const DashboardApp = lazy(() => import("./app/DashboardApp"));
const LoginError = lazy(() => import("./pages/LoginError/LoginErrorPage"))

const root = ReactDOM.createRoot(document.getElementById("root"));

const renderApp = (allowed) => root.render(
    <React.StrictMode>
        <ThemeProvider theme={globalTheme}>
            <CssBaseline/>
            <Suspense>
                {allowed
                 ? (<BrowserRouter>
                        <DashboardApp/>
                    </BrowserRouter>)
                 : (<LoginError/>)}
            </Suspense>
        </ThemeProvider>
    </React.StrictMode>
);

KeycloakService.callLogin(renderApp);
